import { Empty } from 'antd'
import { LeadTimeLineEmptyMessageIcon } from 'components/icons'
import { FC } from 'react'

// Distinct from VoiceEmptyState: Voice is already enabled here, the tenant
// just hasn't made/received a call yet, so no "Integrate" CTA applies.
const NoCallsYetState: FC = () => (
 <div className="no-data-empty-compo">
  <Empty
   image={
    <span className="no-data-image">
     <LeadTimeLineEmptyMessageIcon />
    </span>
   }
   description={
    <span className="no-data-heading">
     No calls yet — they’ll show up here once you make or receive one
    </span>
   }
  />
 </div>
)

export default NoCallsYetState
